import { createRoot } from "react-dom/client";

import { configureSentry } from "./sentry";

// Sentry setup
configureSentry();

import "core-js/stable";

// TailwindCSS v4
import "./assets/css/tailwind.css";

// Import of global styles of the application
import "./assets/scss/base.module.scss";
import "./assets/css/wfp.css";
import "./assets/css/fonts.css";

// Import tippy styles
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";

import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import "./assets/scss/custom-datepicker.module.scss";

import "./i18n";
import { Application } from "./containers/Application";

// Render the root component using the React 19 concurrent API
const rootElement = document.getElementById("index");
if (rootElement) {
  createRoot(rootElement).render(<Application />);
}
